{
  "erreurs.code.ANNONCE_DEJA_RETIREE": "Cette annonce a déjà été retirée : relisez la liste des annonces.",
  "erreurs.code.MAINTENANCE_CHEVAUCHEMENT": "Une autre fenêtre de maintenance planifiée ou en cours recouvre cette période.",
  "erreurs.code.MAINTENANCE_FIN_AVANT_DEBUT": "La fin de la fenêtre de maintenance doit suivre son début ; une prolongation ne raccourcit pas la fenêtre.",
  "erreurs.code.MAINTENANCE_HORS_ETAT": "Ce geste n’est pas possible dans l’état actuel de la fenêtre de maintenance.",
  "erreurs.code.MAINTENANCE_PREAVIS_TROP_COURT": "Préavis trop court : il est sous le minimum de la plateforme ou le début est trop proche pour le tenir.",
  "journalAudit.action.platform.announcement_published": "Annonce diffusée aux organisations",
  "journalAudit.action.platform.announcement_withdrawn": "Annonce retirée",
  "journalAudit.action.platform.maintenance_cancelled": "Maintenance annulée",
  "journalAudit.action.platform.maintenance_ended": "Maintenance terminée",
  "journalAudit.action.platform.maintenance_extended": "Maintenance prolongée",
  "journalAudit.action.platform.maintenance_scheduled": "Maintenance planifiée",
  "journalAudit.action.platform.maintenance_started": "Maintenance commencée",
  "journalAudit.action.platform.status_published": "Page de statut mise à jour",
  "journalAudit.action.platform.terms_published": "Conditions d’utilisation publiées"
}
